import { ApiMetric } from "@incendium/api";
import { ApiDimension } from "@incendium/api";
import { ContentExplorer } from "features/explorer";
import { ExplorerProvider } from "features/explorer";
import { TExploreConfig } from "features/explorer/types";
import { useMemo } from "react";

type Tab = "explore";

function ExistPagesPage() {
  const config: TExploreConfig<Tab> = useMemo(
    () => ({
      explore: {
        title: "Exit Pages Explorer",
        desc: `See where users leave - and why.`,
        type: "top",
        ranking: [],
        analyseBy: {
          description: "Select between Locations or Paths.",
          grouping: [
            {
              option: "Exit Pages By",
              dimensions: [
                ApiDimension.DIMENSION_LOCATION,
                ApiDimension.DIMENSION_PATH,
              ],
            },
          ],
        },
      },
    }),
    []
  );

  return (
    <>
      <ExplorerProvider configs={config} type="explore">
        <ContentExplorer
          dimensionNoClick
          dontIncludeEmpty
          metrics={[
            ApiMetric.METRIC_PAGEVIEWS_COUNT,
            ApiMetric.METRIC_EXIT_PAGEVIEWS_COUNT,
            ApiMetric.METRIC_EXIT_RATE,
            ApiMetric.METRIC_EFFECTIVE_PAGEVIEW_RATE,
            ApiMetric.METRIC_AVERAGE_TIME_ON_PAGE,
            ApiMetric.METRIC_AVERAGE_SCROLL_PERCENTAGE,
            ApiMetric.METRIC_PAGE_MICRO_CONVERSION_RATE,
            ApiMetric.METRIC_PAGE_MACRO_CONVERSION_RATE,
            ApiMetric.METRIC_PAGE_ADD_TO_CART_CLICK_RATE,
            ApiMetric.METRIC_REVENUE,
          ]}
          limit={1000}
          colWidths={{
            [ApiDimension.DIMENSION_EXIT_PAGE_PATH.toString()]: 300,
          }}
        />
      </ExplorerProvider>
    </>
  );
}

export default ExistPagesPage;
